document.addEventListener('cf:ready', function() {
  setTimeout(function() {
    const checkbox = document.querySelector('[name="email_marketing_consent"]');

    if (checkbox) {
      console.log('email_marketing_consent found');
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      console.log('email_marketing_consent not found');
    }
  }, 300);
});

document.addEventListener("click", function(e) {

  if (e.target.classList.contains("cutting-toggle-btn")) {

    let key = e.target.dataset.key;
    let target = document.getElementById("cutting-" + key);

    if (!target) return;

    let isOpen = target.style.display === "block";

    // Close all first (optional - accordion behavior)
    document.querySelectorAll(".cutting-content").forEach(el => {
      el.style.display = "none";
    });

    document.querySelectorAll(".cutting-toggle-btn").forEach(btn => {
      btn.innerHTML = `Cutting Preferences 
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 16 9" fill="">
          <path d="M7.42935 8.55099C7.74027 8.86191 8.25973 8.86191 8.57145 8.55099L15.7638 1.37702C16.0787 1.06211 16.0787 0.551424 15.7638 0.237317C15.4489 -0.0775875 14.9374 -0.0775875 14.6225 0.237317L8.00003 6.8414L1.37834 0.236518C1.06264 -0.0783866 0.551947 -0.0783866 0.236246 0.236518C-0.0786586 0.551422 -0.0786587 1.06211 0.236246 1.37622L7.42935 8.55099Z" fill=""/>
          </svg>
        </span>`;
    });

    // Toggle current
    if (!isOpen) {
      target.style.display = "block";

      e.target.innerHTML = `Cutting Preferences 
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 16 9" fill="">
          <path d="M8.57065 0.233189C8.25973 -0.0777296 7.74027 -0.0777296 7.42855 0.233189L0.236178 7.40716C-0.0787261 7.72207 -0.0787261 8.23276 0.236178 8.54686C0.551083 8.86177 1.06257 8.86177 1.37747 8.54686L7.99997 1.94277L14.6217 8.54766C14.9374 8.86256 15.4481 8.86256 15.7638 8.54766C16.0787 8.23276 16.0787 7.72207 15.7638 7.40796L8.57065 0.233189Z" fill=""/>
          </svg>
        </span>`;
    }

  }

});
  function showStatus(key, text, type = '') {
    const el = document.querySelector(`.save-status[data-key="${key}"]`);
    if (!el) return;

    el.textContent = text;
    el.className = `save-status ${type}`;

    if (type === 'success') {
      setTimeout(() => el.textContent = '', 2000);
    }
  }


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cutting-input').forEach(input => {

    input.addEventListener('blur', function () {
      const key = this.dataset.key;
      const propertyName = this.dataset.properties;
      const value = this.value.trim();

      if (!key || !propertyName) return;
      showStatus(key, 'Saving...', 'loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          properties: {
            [propertyName]: value
          }
        })
      })
      .then(res => res.json())
      .then(data => {
              showStatus(key, 'Saved ✓', 'success');
                      input.style.border = "";

              console.log('Cart updated', data);
      })
      .catch(err => {
              showStatus(key, 'Error!', 'error');

        console.error('Error updating cart:', err);
      });

    });

  });
});

// document.addEventListener('DOMContentLoaded', function () {

//   document.querySelectorAll('.slider-container').forEach(container => {

//     const slider = container.querySelector('.related-slider');

//     // ❌ Skip if grid mode
//     if (!slider || slider.classList.contains('grid-mode')) return;

//     const next = container.querySelector('.next');
//     const prev = container.querySelector('.prev');

//     if (!next || !prev) return;

//     let autoPlay; // ✅ scoped per slider

//     function getScrollAmount() {
//       const card = slider.querySelector('.related-card');
//       if (!card) return 300;
//       return card.offsetWidth + 20;
//     }

//     function slideNext() {
//       const scrollAmount = getScrollAmount();

//       if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5) {
//         slider.scrollTo({ left: 0, behavior: 'smooth' });
//       } else {
//         slider.scrollBy({
//           left: scrollAmount,
//           behavior: 'smooth'
//         });
//       }
//     }

//     // 👉 Buttons
//     next.addEventListener('click', slideNext);

//     prev.addEventListener('click', () => {
//       slider.scrollBy({
//         left: -getScrollAmount(),
//         behavior: 'smooth'
//       });
//     });

//     // 👉 Start autoplay (safe)
//     function startAutoPlay() {
//       stopAutoPlay(); // ✅ prevent stacking
//       autoPlay = setInterval(slideNext, 2500);
//     }

//     function stopAutoPlay() {
//       if (autoPlay) {
//         clearInterval(autoPlay);
//         autoPlay = null;
//       }
//     }

//     // 👉 Init autoplay
//     startAutoPlay();

//     // 👉 Pause on hover
//     container.addEventListener('mouseenter', stopAutoPlay);
//     container.addEventListener('mouseleave', startAutoPlay);

//     // 👉 Optional: Pause when tab inactive (performance boost)
//     document.addEventListener('visibilitychange', () => {
//       if (document.hidden) {
//         stopAutoPlay();
//       } else {
//         startAutoPlay();
//       }
//     });

//   });

// });


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.slider-container').forEach(container => {
    const slider = container.querySelector('.related-slider');
    if (!slider || slider.classList.contains('grid-mode')) return;
    const next = container.querySelector('.related-next-slider');
    const prev = container.querySelector('.related-prev-slider');
    if (!next || !prev) return;
    // arrows
    prev.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path d="M15 18L9 12L15 6" fill="none" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
    next.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <path d="M9 18L15 12L9 6" fill="none" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
    let autoplay;
    function getCardCount() {
      return slider.querySelectorAll('.related-card').length;
    }
    function getBreakpoint() {
      const w = window.innerWidth;
      if (w <= 767) return 'mobile';
      if (w <= 1024) return 'ipad';
      return 'desktop';
    }
    function getMinCardsForArrows() {
      const bp = getBreakpoint();
      if (bp === 'mobile') return 3;
      if (bp === 'ipad') return 3;
      return 5;
    }
    function shouldHideArrows() {
      const cardCount = getCardCount();
      if (cardCount < 2) return true; // global rule
      const minCards = getMinCardsForArrows();
      return cardCount < minCards;
    }
    function updateArrowVisibility() {
      const hide = shouldHideArrows();
      next.style.display = hide ? 'none' : 'flex';
      prev.style.display = hide ? 'none' : 'flex';
      container.classList.toggle('arrows-hidden', hide);
      if (hide) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }
    function getCardWidth() {
      const card = slider.querySelector('.related-card');
      if (!card) return 300;
      const gap = parseInt(getComputedStyle(slider).gap) || 20;
      return card.offsetWidth + gap;
    }
    function slideNext() {
      const amount = getCardWidth();
      if (
        slider.scrollLeft + slider.clientWidth >=
        slider.scrollWidth - 5
      ) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }
    }
    function slidePrev() {
      const amount = getCardWidth();
      if (slider.scrollLeft <= 0) {
        slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: -amount, behavior: 'smooth' });
      }
    }
    next.addEventListener('click', slideNext);
    prev.addEventListener('click', slidePrev);
    function startAutoplay() {
      stopAutoplay();
      if (shouldHideArrows()) return;
      autoplay = setInterval(() => {
        slideNext();
      }, 2500);
    }
    function stopAutoplay() {
      if (autoplay) {
        clearInterval(autoplay);
        autoplay = null;
      }
    }
    // Initial setup
    updateArrowVisibility();
    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
    // Re-check on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateArrowVisibility, 150);
    });
  });
});